<template>
  <div class="post_SpentTime">
    <div class="weeklyBox" style="box-shadow: none;">
       <el-form
                :model="weeklyReportViewData"
                :rules="rules"
                ref="timeRuleForm"
                @submit.native.prevent
                :show-message="false"
                >
      <table cellspacing="0" cellpadding="0" class="weeklyReportTable">
        <tbody>
          <tr>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd" width="20%">&nbsp;</td>
            <!-- <td class="td_timeAdd" width="15%">&nbsp;</td> -->
            <td class="td_timeAdd td_center dayDateArea"  width="8%">
              <span>一</span>
              <br />
              <span>{{weekArray[0]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center dayDateArea" width="8%">
              <span>二</span>
              <br />
              <span>{{weekArray[1]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center dayDateArea" width="8%">
              <span>三</span>
              <br />
              <span>{{weekArray[2]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center dayDateArea" width="8%">
              <span>四</span>
              <br />
              <span>{{weekArray[3]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center dayDateArea" width="8%">
              <span>五</span>
              <br />
              <span>{{weekArray[4]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center redTitle dayDateArea" width="8%">
              <span>六</span>
              <br />
              <span>{{weekArray[5]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd td_center redTitle dayDateArea" width="8%">
              <span>七</span>
              <br />
              <span>{{weekArray[6]|weekDateShow}}</span>
            </td>
            <td class="td_timeAdd" width="4%">&nbsp;</td>
          </tr>
        </tbody>
        <tbody>
          <tr class="td_timeAdd_tr tableTitleRow">
            <!-- <td class="td_timeAdd " :rowspan="projectRow" style="line-height: 20px;">
               项目 
              <div>
                <el-button
                  type="text"
                  @click="addProject()" class="pulsBtn">
                  <i class="el-icon-plus"></i>
                </el-button>
              </div> 
            </td> -->
            <td class="td_timeAdd" style="line-height: 20px;">项目</td>
            <!-- <td class="td_timeAdd">项目类型</td> -->
            <td class="td_timeAdd">任务类别</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
          </tr>
           <!-- <tr class="td_timeAdd_tr" v-if="weeklyReportViewData.projectList.length==0">
            <td class="td_timeAdd ">
           
            </td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
          </tr> -->
          <!-- v-else -->
          <tr  v-for="(projectItem,index) in weeklyReportViewData.projectList" :key="index">
            <td class="td_timeAdd">
                <el-form-item label=" " 
                 :prop="'projectList.' + index + '.projectId'"
                   :rules="rules.projectId">
                  <!-- <span>
                        {{projectItem.projectName}}
                         {{projectItem.projectSerialNumber!=""?" (" + projectItem.projectSerialNumber + ")":""}}
                      </span> -->
                  <el-input
                    v-model="projectItem.projectName"
                    readonly></el-input>
                  <div class="tableChoose_btn">
                    <el-button
                      type="text"
                      size="medium"
                      @click="showChooseProjectView(projectItem,index)">选</el-button>
                    <el-button
                      type="text"
                      size="medium"
                      @click="clearProject(projectItem,index)">清</el-button>
                  </div>
                </el-form-item>
             
            </td>
            <td class="td_timeAdd">
              <!-- <span style="font-size:14px;color:#606266;">{{projectItem.projectName}}</span> -->
                    <el-form-item label=" " 
                    :prop="'projectList.' + index + '.projectTaskId'" :rules="rules.projectTaskId">
                      <!-- <span>{{projectItem.projectTaskName}}</span> -->
                      <el-input v-model="projectItem.projectTaskName" readonly></el-input>
                      <div class="tableChoose_btn">
                        <el-button
                          type="text"
                          size="medium"
                          @click="showChooseProjectTaskView(projectItem,index)">选</el-button>
                        <el-button
                          type="text"
                          size="medium"
                          @click="clearProjectTask(projectItem)">清</el-button>
                      </div>
                    </el-form-item>
            </td>

            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Monday'].content">
              <div slot="content">{{projectItem['Monday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(projectItem['Monday'])">
                <el-input
                  v-model="projectItem['Monday'].spentTime"
                  @change="changeSpentTime(projectItem['Monday'])"></el-input>
                <div class="tipBar" v-if="projectItem['Monday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Tuesday'].content">
              <div slot="content">{{projectItem['Tuesday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(projectItem['Tuesday'])">
                <el-input
                  v-model="projectItem['Tuesday'].spentTime"
                  @change="changeSpentTime(projectItem['Tuesday'])"
                ></el-input>
                <div class="tipBar" v-if="projectItem['Tuesday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Wednesday'].content">
              <div slot="content">{{projectItem['Wednesday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput"
                @dblclick="showContentView(projectItem['Wednesday'])">
                <el-input
                  v-model="projectItem['Wednesday'].spentTime"
                  @change="changeSpentTime(projectItem['Wednesday'])"></el-input>
                <div class="tipBar" v-if="projectItem['Wednesday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Thursday'].content">
              <div slot="content">{{projectItem['Thursday'].content}}</div>
              <td
                class="td_timeAdd td_spentTimeInput"
                @dblclick="showContentView(projectItem['Thursday'])">
                <el-input
                  v-model="projectItem['Thursday'].spentTime"
                  @change="changeSpentTime(projectItem['Thursday'])"></el-input>
                <div class="tipBar" v-if="projectItem['Thursday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Friday'].content">
              <div slot="content">{{projectItem['Friday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(projectItem['Friday'])">
                <el-input
                  v-model="projectItem['Friday'].spentTime"
                  @change="changeSpentTime(projectItem['Friday'])"
                ></el-input>
                <div class="tipBar" v-if="projectItem['Friday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Saturday'].content">
              <div slot="content">{{projectItem['Saturday'].content}}</div>
              <td
                class="td_timeAdd td_spentTimeInput"
                @dblclick="showContentView(projectItem['Saturday'])">
                <el-input
                  v-model="projectItem['Saturday'].spentTime"
                  @change="changeSpentTime(projectItem['Saturday'])"></el-input>
                <div class="tipBar" v-if="projectItem['Saturday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!projectItem['Sunday'].content">
              <div slot="content">{{projectItem['Sunday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(projectItem['Sunday'])">
                <el-input
                  v-model="projectItem['Sunday'].spentTime"
                  @change="changeSpentTime(projectItem['Sunday'])"></el-input>
                <div class="tipBar" v-if="projectItem['Sunday'].content"></div>
              </td>
            </el-tooltip>
            <td class="td_timeAdd">
              <el-button
                type="text"
                @click="removeProject(index)"
                class="removeBtn">移除</el-button>
            </td>
          </tr>
          <tr class="td_timeAdd_tr">
            <td class="td_timeAdd ">
                <div>
                  <el-button
                    plain size="mini"
                    @click="addProject()">添加
                  </el-button>
                </div>
            </td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
          </tr>
         
        </tbody>
        <tbody>
          <tr class="td_timeAdd_tr tableTitleRow">
            <!-- <td class="td_timeAdd " :rowspan="taskRow" style="line-height: 20px;">
              任务
              <div>
                <el-button type="text" @click="addTask()" class="pulsBtn">
                  <i class="el-icon-plus"></i>
                </el-button>
              </div>
            </td> -->
            <td class="td_timeAdd" colspan="2" style="line-height: 20px;">日常工作</td>
            <!-- <td class="td_timeAdd">&nbsp;</td> -->
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd">&nbsp;</td>
          </tr>
           <!-- <tr class="td_timeAdd_tr" v-if="weeklyReportViewData.taskList.length==0">
            <td class="td_timeAdd ">
            </td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
             <td class="td_timeAdd">&nbsp;</td>
          </tr> -->
          <tr v-for="(taskItem,index) in  weeklyReportViewData.taskList " :key="index">
            <td class="td_timeAdd" colspan="2">
                <el-form-item label=" " :prop="'taskList.' + index + '.taskId'" :rules="rules.taskId">
                  <el-select v-model="taskItem.taskId">
                  <!-- @change="changeTask(taskItem,index)" -->
                    <el-option
                      v-for="item in taskList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                      </el-option>
                  </el-select>
                </el-form-item>
            </td>
            <!-- <td class="td_timeAdd"></td> -->
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Monday'].content">
              <div slot="content">{{taskItem['Monday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(taskItem['Monday'])">
                <el-input
                  v-model="taskItem['Monday'].spentTime"
                  @change="changeSpentTime(taskItem['Monday'])"
                ></el-input>
                <div class="tipBar" v-if="taskItem['Monday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Tuesday'].content">
              <div slot="content">{{taskItem['Tuesday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(taskItem['Tuesday'])">
                <el-input
                  v-model="taskItem['Tuesday'].spentTime"
                  @change="changeSpentTime(taskItem['Tuesday'])"></el-input>
                <div class="tipBar" v-if="taskItem['Tuesday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip
              placement="bottom"
              effect="light"
              :disabled="!taskItem['Wednesday'].content">
              <div slot="content">{{taskItem['Wednesday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(taskItem['Wednesday'])">
                <el-input
                  v-model="taskItem['Wednesday'].spentTime"
                  @change="changeSpentTime(taskItem['Wednesday'])"></el-input>
                <div class="tipBar" v-if="taskItem['Wednesday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Thursday'].content">
              <div slot="content">{{taskItem['Thursday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(taskItem['Thursday'])">
                <el-input
                  v-model="taskItem['Thursday'].spentTime"
                  @change="changeSpentTime(taskItem['Thursday'])"></el-input>
                <div class="tipBar" v-if="taskItem['Thursday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Friday'].content">
              <div slot="content">{{taskItem['Friday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(taskItem['Friday'])">
                <el-input
                  v-model="taskItem['Friday'].spentTime"
                  @change="changeSpentTime(taskItem['Friday'])"></el-input>
                <div class="tipBar" v-if="taskItem['Friday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Saturday'].content">
              <div slot="content">{{taskItem['Saturday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(taskItem['Saturday'])">
                <el-input
                  v-model="taskItem['Saturday'].spentTime"
                  @change="changeSpentTime(taskItem['Saturday'])"></el-input>
                <div class="tipBar" v-if="taskItem['Saturday'].content"></div>
              </td>
            </el-tooltip>
            <el-tooltip placement="bottom" effect="light" :disabled="!taskItem['Sunday'].content">
              <div slot="content">{{taskItem['Sunday'].content}}</div>
              <td class="td_timeAdd td_spentTimeInput" @dblclick="showContentView(taskItem['Sunday'])">
                <el-input
                  v-model="taskItem['Sunday'].spentTime"
                  @change="changeSpentTime(taskItem['Sunday'])"></el-input>
                <div class="tipBar" v-if="taskItem['Sunday'].content"></div>
              </td>
            </el-tooltip>
            <td class="td_timeAdd">
              <el-button type="text" @click="removeTask(index)" class="removeBtn">移除</el-button>
            </td>
          </tr>
          <tr class="td_timeAdd_tr">
            <td class="td_timeAdd " colspan="2">
               <div>
                  <el-button
                    plain size="mini"
                    @click="addTask()">添加
                  </el-button>
                </div>
            </td>
            <!-- <td class="td_timeAdd"></td> -->
            <td class="td_timeAdd"></td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
            <td class="td_timeAdd">&nbsp;</td>
             <td class="td_timeAdd">&nbsp;</td>
          </tr>
        </tbody>
        <tbody>
          <tr>
           
            <td class="td_timeAdd" colspan="2">总计</td>
            <!-- <td class="td_timeAdd" width="10%">&nbsp;</td> -->
           
            <td class="td_timeAdd td_center">
              {{weeklyReportViewData.dailySpentTimeArray[0]}}
            </td>
            <td class="td_timeAdd td_center">
              {{weeklyReportViewData.dailySpentTimeArray[1]}}
            </td>
            <td class="td_timeAdd td_center">
              {{weeklyReportViewData.dailySpentTimeArray[2]}}
            </td>
            <td class="td_timeAdd td_center">
              {{weeklyReportViewData.dailySpentTimeArray[3]}}
            </td>
            <td class="td_timeAdd td_center">
              {{weeklyReportViewData.dailySpentTimeArray[4]}}
            </td>
            <td class="td_timeAdd td_center">
              {{weeklyReportViewData.dailySpentTimeArray[5]}}
            </td>
            <td class="td_timeAdd td_center">
              {{weeklyReportViewData.dailySpentTimeArray[6]}}
            </td>
            <td class="td_timeAdd">
            </td>
          </tr>
          
        </tbody>
      </table>
       </el-form>
    </div>
    <p style="color:#777777;font-size:15px;margin-bottom:20px;margin-right:20px;">双击工时可查看或填写工作内容。</p>

    <el-dialog
      title="备注信息"
      :visible.sync="contentVisible"
      :close-on-click-modal="false"
      width="600px"
      @close="closeContentView()"
      class="contentModal"
      :close-on-press-escape="false">
      <div class="modalForm">
        <el-form
          :model="contentFormTemp"
          label-position="left"
          ref="contentFormTemp"
          size="small"
          label-width="60px"
          @submit.native.prevent>
          <el-form-item label="备注:" prop="serialNumber">
            <el-input type="textarea" v-model="contentFormTemp.content" :rows="6"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="text" @click="saveContent()">保存</el-button>
        <el-button type="text" @click="closeContentView()">取消</el-button>
      </div>
    </el-dialog>
    <chooseProject
      ref="chooseProject"
      :propsData="projectChooseViewProps"
      @chooseProjectCallback="chooseProjectCallback"></chooseProject>

      <chooseProjectTask
        ref="chooseProjectTask"
        :propsData="projectTaskChooseViewProps"
        @chooseProjectTaskCallback="chooseProjectTaskCallback"></chooseProjectTask>
  </div>
</template>

<script>
import { dateFtt, isArrayRepeat } from "@/utils/auth.js";
import chooseProject from "../common/chooseProject";
import chooseProjectTask from "../common/chooseProjectTask";

export default {
  name: "post_SpentTime",
  components: { chooseProject,chooseProjectTask },
  props: ["taskList", "currentWeekInfo", "getWeeklyReportByUserArgs"],
  data() {
    return {
      projectChooseViewProps: {
        visible: false
      },
      projectTaskChooseViewProps:{
         visible: false,
        projectId:""
      },
      contentForm: {
        content: ""
      },
      contentFormTemp: {
        content: ""
      },
      contentVisible: false,
      rules: {
        // spentTime: [
        //   { required: true, message: "请输入工时", trigger: "change" }
        // ],
        taskId: [
          { required: true, message: "请选择工作", trigger: "change" }
        ],
        projectId: [
          { required: true, message: "请选择项目", trigger: "change" }
        ],
         projectTaskId: [
          { required: true, message: "请选择任务类别", trigger: "change" }
        ]
      },
      weekDayArray: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      // UI展示数据
      weeklyReportViewData: {
        taskList: [],
        projectList: [],
        dailySpentTimeArray: []
      },
      weekArray: [], //当前周次的时间集合 从周一到周日

      //记录对应的条目有多少行，用来合并单元格
      projectRow: 2,
      taskRow: 2,
      editingProjectItem: {},
      chooseProjectIndex: 0 //记录当前项目选择的位置
    };
  },
  filters: {
    weekDateShow: function(value) {
      return dateFtt("MM/dd", value);
    }
  },
  methods: {
    
    //data是服务端返回的原始周报数据
    loadWeeklyReportData(data) {
      this.createWeekArray();
      this.convertServerDataToViewData(data);
      this.computeDailyTotalSpentTime();
      
      this.projectRow = this.weeklyReportViewData.projectList.length + 2;

      if(this.weeklyReportViewData.taskList.length == 0){
        this.taskRow = this.weeklyReportViewData.taskList.length + 2;
      }
      else{
         this.taskRow = this.weeklyReportViewData.taskList.length + 1;
      }

    },

    //按工时填写转化
    convertServerDataToViewData(data) 
    {
      this.weeklyReportViewData.taskList = [];
      this.weeklyReportViewData.projectList = [];

      if (data == null) 
        return;

     // let weeklyReportForm = data;
     
      let spentTimeTaskArray = [];
      let spentTimeProjectArray = [];
      let currentDay;
      let weeklyReportItem_Task = data.weeklyReportItem_Task || [];
      let weeklyReportItem_Project = data.weeklyReportItem_Project || [];

      let weekDayTemp = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      /*
      获取已填报的周报，按照日常工作类型分类。
      格式[taskId:'',taskName:"",Monday:{},Tuesday:{},Wednesday:{},Thursday:{},Friday:{},Saturday:{},Sunday:{}]
      */
      weeklyReportItem_Task.forEach(taskItem => 
      {
        currentDay = weekDayTemp[new Date(taskItem.date).getDay()];

        if (spentTimeTaskArray.length == 0) 
        {
          let spentTimeTaskItem = {};
          spentTimeTaskItem.taskId = taskItem.taskId;
          spentTimeTaskItem.taskName = taskItem.taskName;
          spentTimeTaskItem[currentDay] = taskItem;
          spentTimeTaskArray.push(spentTimeTaskItem);
        } 
        else 
        {
          let needToAdd = true;

          for(let i=0;i<spentTimeTaskArray.length;i++)
          {
              let spentTimeItem = spentTimeTaskArray[i];

              if (spentTimeItem.taskId == taskItem.taskId
              && spentTimeItem[currentDay] == undefined) 
              {
                needToAdd = false;
                spentTimeItem[currentDay] = taskItem;
                break;
              }
          }

           if (needToAdd) 
           {
            let unExistTaskItem = {};
            unExistTaskItem.taskId = taskItem.taskId;
            unExistTaskItem.taskName = taskItem.taskName;
            unExistTaskItem[currentDay] = taskItem;
            spentTimeTaskArray.push(unExistTaskItem);
           }
        }
      });

      /*
      获取已填报的周报，按照项目类型分类。
      格式[projectId:'',projectName:"",projectSerialNumber:"",Monday:{},Tuesday:{},Wednesday:{},Thursday:{},Friday:{},Saturday:{},Sunday:{}]
      */
      weeklyReportItem_Project.forEach(projectItem => 
      {
        currentDay = weekDayTemp[new Date(projectItem.date).getDay()];
      //  console.log(currentDay);
     //  console.log(projectItem.spentTime);

        if (spentTimeProjectArray.length == 0) 
        {
          let spentTimeProjectItem = {};
          spentTimeProjectItem.projectId = projectItem.projectId;
          spentTimeProjectItem.projectStatusId = projectItem.projectStatusId;
          spentTimeProjectItem.projectTaskId = projectItem.projectTaskId;
          spentTimeProjectItem.projectName = projectItem.projectName;
          spentTimeProjectItem.projectTaskName = projectItem.projectTaskName;
          spentTimeProjectItem.projectSerialNumber = projectItem.projectSerialNumber;
          spentTimeProjectItem[currentDay] = projectItem;
          spentTimeProjectArray.push(spentTimeProjectItem);
        }
        else 
        {
          let needToAdd = true;

          for(let i=0;i<spentTimeProjectArray.length;i++)
          {
            // console.log(spentTimeProjectItem[currentDay]);

            let spentTimeProjectItem = spentTimeProjectArray[i];

            if (spentTimeProjectItem.projectId == projectItem.projectId
              && spentTimeProjectItem.projectTaskId == projectItem.projectTaskId
              && spentTimeProjectItem[currentDay] == undefined
              )
            {
              needToAdd = false;
              spentTimeProjectItem[currentDay] = projectItem;
              break;
            }
          }

          if (needToAdd) 
          {
            let unSpentTimeProjectItem = {};
            unSpentTimeProjectItem.projectId = projectItem.projectId;
            unSpentTimeProjectItem.projectStatusId = projectItem.projectStatusId;
            unSpentTimeProjectItem.projectTaskId = projectItem.projectTaskId;
            unSpentTimeProjectItem.projectName = projectItem.projectName;
            unSpentTimeProjectItem.projectTaskName = projectItem.projectTaskName;
            unSpentTimeProjectItem.projectSerialNumber = projectItem.projectSerialNumber;
            unSpentTimeProjectItem[currentDay] = projectItem;
            spentTimeProjectArray.push(unSpentTimeProjectItem);
          }
        }
      });

      let fitWeeklyPortForm = this.fitEmptyweekDayReport(spentTimeTaskArray,spentTimeProjectArray);
      this.weeklyReportViewData.taskList = fitWeeklyPortForm.spentTimeTaskArray;
      this.weeklyReportViewData.projectList = fitWeeklyPortForm.spentTimeProjectArray;

    },

    //补充当前周次未填写周报日期的对象内容。
    //方法内注释部分为: 默认在没有填写周报的时候展示一条空数据
    fitEmptyweekDayReport(spentTimeTaskArray = [],spentTimeProjectArray = []) {
      this.weekDayArray.forEach((dayItem, index) => {
        if (spentTimeTaskArray.length == 0) {
          // let taskitem = {};
          // taskitem[dayItem] = {};
          // taskitem[dayItem].spentTime = "";
          // taskitem[dayItem].content = "";
          // taskitem[dayItem].date = this.weekArray[index];
          // taskitem[dayItem].taskId = "";
          // taskitem[dayItem].numericalOrder = 1;
          // timeTask.push(taskitem);
        } else {
          
          spentTimeTaskArray.forEach(taskitem => {
            if (!taskitem[dayItem]) {
              taskitem[dayItem] = {};
              taskitem[dayItem].spentTime = "";
              taskitem[dayItem].content = "";
              taskitem[dayItem].date = this.weekArray[index];
              taskitem[dayItem].taskId = "";
              taskitem[dayItem].numericalOrder = 1;
            }
          });
        }
        if (spentTimeProjectArray.length == 0) {
          // let item = {};
          // item[dayItem] = {};
          // item[dayItem].content = "";
          // item[dayItem].date = this.weekArray[index];
          // item[dayItem].numericalOrder = 1;
          // item[dayItem].spentTime = "";
          // item[dayItem].projectId = "";
          // timeBusiness.push(item);
        } else {
          spentTimeProjectArray.forEach(item => {
            if (!item[dayItem]) {
              item[dayItem] = {};
              item[dayItem].content = "";
              item[dayItem].date = this.weekArray[index];
              item[dayItem].numericalOrder = 1;
              item[dayItem].spentTime = "";
              item[dayItem].projectId = "";
              // item[dayItem].projectSerialNumber = "";
            }
          });
        }
      });
      return {
        spentTimeTaskArray: spentTimeTaskArray,
        spentTimeProjectArray: spentTimeProjectArray
      };
    },

    //在工时视图统计每天的工时合计
    computeDailyTotalSpentTime() {
      this.weeklyReportViewData.dailySpentTimeArray = [];

      this.weekDayArray.forEach(dayItem => {
        let sum = 0;
        
        this.weeklyReportViewData.taskList.forEach(taskItem => {
          sum += Number(taskItem[dayItem].spentTime||0);
        });

        this.weeklyReportViewData.projectList.forEach(item => {
          sum += Number(item[dayItem].spentTime||0);
        });
        if (sum == 0) {
          sum = "";
        }
        this.weeklyReportViewData.dailySpentTimeArray.push(sum);
      });
    },

    //初始化每周日期
    createWeekArray() {
      this.weekArray = [];
      let currentWeek = this.currentWeekInfo;
      for (var i = 0; i < 7; i++) {
        let itemDay = dateFtt(
          "yyyy/MM/dd hh:mm:ss",
          new Date(currentWeek.monday).getTime() + 24 * 60 * 60 * 1000 * i
        );
        this.weekArray.push(itemDay);
      }
    },

    //选择项目按钮
    showChooseProjectView(projectItemInViewData, index) {
      this.editingProjectItem = projectItemInViewData;
      this.chooseProjectIndex = index;

      this.$refs.chooseProject.show();
    },

    //选择项目回调
    chooseProjectCallback(args) {
      this.editingProjectItem.projectId = args.id;
      this.editingProjectItem.projectStatusId = args.statusId;
      this.editingProjectItem.projectSerialNumber = args.serialNumber;
      this.editingProjectItem.projectName = args.name;

      this.clearProjectTask(this.editingProjectItem);

      this.changeProjectOnSpentTimeView(this.editingProjectItem,this.chooseProjectIndex);
    },

    //清除项目
    clearProject(projectItem) {
      projectItem.projectSerialNumber = "";
      projectItem.projectId = "";
      projectItem.projectStatusId = "",
      projectItem.projectName = "";
      projectItem.projectTaskId = "";
      projectItem.projectTaskName = "";
    },

    //选择任务类别
    showChooseProjectTaskView(projectItemInViewData, index){
        if(!projectItemInViewData.projectId){
          this.$alert("请先选择一个项目。", "提示");
          return;
        }

        this.editingProjectItem = projectItemInViewData;
        this.$refs.chooseProjectTask.show(projectItemInViewData.projectId);
    },

    //选择任务类别回调
    chooseProjectTaskCallback(args) {

      this.editingProjectItem.projectTaskId = args.id;
      this.editingProjectItem.projectTaskName = args.name;
 
   //   this.changeProject();
    },

    //清除任务类别
    clearProjectTask(projectItem){
       projectItem.projectTaskId = "";
       projectItem.projectTaskName = "";
    },
    
    //判断选择的项目是不是已经存在
    changeProjectOnSpentTimeView(item, index) {
      // this.weeklyReportViewData.projectList.forEach(
      //   (val, j) => {
      //     if (j == index) return;
      //     if (val.projectId == item.projectId) {
      //       this.$alert("该项目已存在，请勿重复添加", "提示");
      //       item.projectId = "";
      //       item.projectTypeName = "";
      //       item.projectName = "";
      //       item.projectSerialNumber = "";
      //     }
      //   }
      // );
    },

    //判断选择的任务类型是不是已经存在
    // changeTask(item, index) {
    //   this.weeklyReportViewData.taskList.forEach((val, j) => {
    //     if (j == index) return;
    //     if (val.taskId == item.taskId) {
    //       this.$alert("该日常工作已存在，请勿重复添加", "提示");
    //       item.taskId = "";
    //     }
    //   });
    // },

    //添加项目
    addProject() {
      let projectItem = {
        projectId: "",
        projectStatusId:"",
        projectTaskId:"",
        projectName: "",
        projectTaskName:"",
        projectSerialNumber: "",
        projectTypeName: "",
        Monday: {},
        Tuesday: {},
        Wednesday: {},
        Thursday: {},
        Friday: {},
        Saturday: {},
        Sunday: {}
      };
      this.weekDayArray.forEach((dayItem, index) => {
        projectItem[dayItem] = {};
        projectItem[dayItem].content = "";
        projectItem[dayItem].date = this.weekArray[index];
        projectItem[dayItem].numericalOrder = 1;
        projectItem[dayItem].spentTime = "";
        projectItem[dayItem].projectId = "";
      });
      this.weeklyReportViewData.projectList.push(
        projectItem
      );
      this.projectRow = this.weeklyReportViewData.projectList.length + 2;
      this.showChooseProjectView(
        projectItem,
        this.weeklyReportViewData.projectList.length - 1
      );
    },

    //添加任务类型
    addTask() {
      let taskItem = {
        taskId: "",
        taskName: "",
        Monday: {},
        Tuesday: {},
        Wednesday: {},
        Thursday: {},
        Friday: {},
        Saturday: {},
        Sunday: {}
      };
      
      this.weekDayArray.forEach((dayItem, index) => {
        taskItem[dayItem] = {};
        taskItem[dayItem].spentTime = "";
        taskItem[dayItem].content = "";
        taskItem[dayItem].date = this.weekArray[index];
        taskItem[dayItem].taskId = "";
        taskItem[dayItem].numericalOrder = 1;
      });
      this.weeklyReportViewData.taskList.push(taskItem);
      this.taskRow = this.weeklyReportViewData.taskList.length + 2;
    },

    //在工时视图修改工时
    changeSpentTime(item) {
      if (isNaN(item.spentTime)) {
        item.spentTime = "";
      }
      this.computeDailyTotalSpentTime();
    },

    //移除
    removeProject(index) {
      this.weeklyReportViewData.projectList.splice(index, 1);
      this.computeDailyTotalSpentTime();
      this.projectRow = this.weeklyReportViewData.projectList.length + 2;
    },
    removeTask(index) {
      this.weeklyReportViewData.taskList.splice(index, 1);
      this.computeDailyTotalSpentTime();
      this.taskRow = this.weeklyReportViewData.taskList.length + 2;
    },

    // 双击查看备注
    showContentView(currentline) {
      console.log(currentline);
      this.contentVisible = true;
      this.contentForm = currentline;
      this.contentFormTemp.content = currentline.content;
    },

    saveContent() {
      this.contentForm.content = this.contentFormTemp.content;
      this.contentVisible = false;
    },

    closeContentView() {
      this.contentFormTemp.content = "";
      this.contentVisible = false;
    },

    // 工时视图格式转化为提交格式
    convertViewDataToServerData() 
    {
      let weeklyReportSubmitForm = {};

      weeklyReportSubmitForm.year = this.getWeeklyReportByUserArgs.year;
      weeklyReportSubmitForm.month = this.getWeeklyReportByUserArgs.month;
      weeklyReportSubmitForm.weekOfYear = this.getWeeklyReportByUserArgs.weekOfYear;
     
      let spentTimeTaskListInViewData = this.weeklyReportViewData.taskList || [];
      let spentTimeprojectListInViewData = this.weeklyReportViewData.projectList || [];

      weeklyReportSubmitForm.weeklyReportItem_Task = [];
      weeklyReportSubmitForm.weeklyReportItem_Project = [];

    //console.log(JSON.stringify(spentTimeTaskListInViewData));

      //这里的taskItem对象不是对应后台的taskItem
      //而是根据前端显示要求的格式，包括 taskId，taskName 和 各个星期命名的属性
      spentTimeTaskListInViewData.forEach(taskItem => 
      {
        for (let key in taskItem) 
        {
          if (taskItem[key] instanceof Object) 
          {
             if((taskItem[key].content == "" || taskItem[key].content == null) 
                && (taskItem[key].spentTime == "" || taskItem[key].spentTime == null))
              {
                continue;
              }

            taskItem[key].taskId = taskItem.taskId;
            taskItem[key].taskName = taskItem.taskName;
            taskItem[key].year = weeklyReportSubmitForm.year;
            taskItem[key].month = weeklyReportSubmitForm.month;
            weeklyReportSubmitForm.weeklyReportItem_Task.push(taskItem[key]);
          }
        }
      });

      spentTimeprojectListInViewData.forEach(projectItem => 
      {
        for (let key in projectItem) 
        {
          if (projectItem[key] instanceof Object) 
          {
            if((projectItem[key].content == "" || projectItem[key].content == null) 
                && (projectItem[key].spentTime == "" || projectItem[key].spentTime == null))
              {
                continue;
              }

            projectItem[key].projectId = projectItem.projectId;
            projectItem[key].projectStatusId = projectItem.projectStatusId;
            projectItem[key].projectTaskId = projectItem.projectTaskId;
            projectItem[key].projectName = projectItem.projectName;
            projectItem[key].projectTaskName = projectItem.projectTaskName;
            projectItem[key].projectSerialNumber = projectItem.projectSerialNumber;
            projectItem[key].year = weeklyReportSubmitForm.year;
            projectItem[key].month = weeklyReportSubmitForm.month;
            weeklyReportSubmitForm.weeklyReportItem_Project.push(projectItem[key]);
          }
        }
      });

     // console.log(JSON.stringify(weeklyReportSubmitForm));
      return weeklyReportSubmitForm;
    },

    //验证输入
    validate()
    {
        let validateResult = true;
        this.$refs["timeRuleForm"].validate(valid => 
          {
            if (!valid) 
            {
              validateResult = false;
            }
          });

        return validateResult;
    },

  }
};
</script>


<style rel="stylesheet/scss" lang="scss">
.post_SpentTime {
  font-size: 14px;

  .tableTitleRow{
    font-weight:bold;
    color:rgb(88, 88, 88);
  }

  .dayDateArea
  {
    // border: solid 1px rgb(197, 216, 238);
    background-color: rgb(247, 247, 232);
  }

  .weeklyBox {
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 20px;
    padding-right: 0;
    // box-shadow: 0px 0px 0px 2px #f5f5f5;
    // box-shadow: inset 0px 0px 0px 4px #f5f5f5;
  }
  .weeklyReportTable {
    // border-left: 1px solid #ebeef5;
    // border-right: 1px solid #ebeef5;
      width:100%;
     border-collapse:collapse;
     border:1px solid #ebeef5;

    //  td
    //   {
    //   border:1px solid #ebeef5;
    //   }

    .td_spentTimeInput
    {
       border: solid 1px rgb(197, 216, 238) ;

        .el-input__inner
        {
          text-align: center;
        }
    }

    .el-input 
    .el-input__inner,
    .el-input__icon,
    .el-form-item__content {
      // border: none !important;
      height: 30px;
    }
    // .el-textarea 
    // .el-textarea__inner {
    //    border: none !important;
    // }
  //  .el-input
  //  .el-input--suffix
  //  .el-input__inner{
  //   // border-bottom: 1px solid #bbbbbb !important;
  //    border-radius: 0;
  //  }

   .el-input__inner,
    .el-textarea__inner {
      //  border: none !important;
      border-top:none !important;
      border-left:none !important;
      border-right:none !important;
      border-bottom: 1px solid #ffffff;
      border-radius: 0 !important;
      padding: 0;
    }

    .el-form-item.is-error 
    .el-input__inner, 
    .el-form-item.is-error 
    .el-input__inner:focus, 
    .el-form-item.is-error 
    .el-textarea__inner, 
    .el-form-item.is-error 
    .el-textarea__inner:focus
    {
      border-bottom: 1px solid red;
    }

    .td_timeAdd {
      // border-bottom: 1px solid #ebeef5;
      // border-right: 1px solid #ebeef5;
      padding: 5px 10px;
      position: relative;
      .el-form {
        height: 35px !important;
      }
    }
  //  .el-input__inner,
    .td_center {
      text-align: center;
    }

    .td_timeAdd_tr {
      height: 30px;
      line-height: 30px;
    }
    .tipBar {
      height: 10px;
      width: 10px;
      background-image: url("../../assets/r2c2.jpg");
      position: absolute;
      right: 0px;
      bottom: 15px;
    }
  }


}
</style>


// WEBPACK FOOTER //
// src/views/weeklyReport/post_SpentTime.vue